export type TpAbrangenciaInforme = "S" | "E";

export interface InformeEvento {
  cdSeqInformeEvento: number;
  noInforme: string;
  dsInforme: string;
  tpAbrangencia: string;
  nuEventoVinculo: number;
  dtInicioInforme: string;
  dtFimInforme: string;
  stInforme: string;
  stAtivo: boolean;
  dtCriacao: string;
  noUsuarioCriacao: string;
  dtAtualizacao: string;
  noUsuarioAtualizacao: string;
}

export const AbrangenciaInforme = {
  SISTEMA: "S" as TpAbrangenciaInforme,
  EVENTO: "E" as TpAbrangenciaInforme,
};

export function getAbrangencia(
  informe: InformeEvento
): TpAbrangenciaInforme | null {
  const tipo = (informe.tpAbrangencia || "").trim().toUpperCase();
  if (tipo === AbrangenciaInforme.SISTEMA) {
    return AbrangenciaInforme.SISTEMA;
  }
  if (tipo === AbrangenciaInforme.EVENTO) {
    return AbrangenciaInforme.EVENTO;
  }
  return null;
}

export function isInformeSistema(informe: InformeEvento): boolean {
  return getAbrangencia(informe) === AbrangenciaInforme.SISTEMA;
}

export function isInformeEvento(informe: InformeEvento): boolean {
  return getAbrangencia(informe) === AbrangenciaInforme.EVENTO;
}

/**
 * Reforça no cliente a regra de exibição (RN001/RN004): apenas informes com
 * status ativo cuja data/hora atual esteja dentro da janela de vigência.
 */
export function isInformeVigente(
  informe: InformeEvento,
  agora: Date = new Date()
): boolean {
  if (!informe.stAtivo) {
    return false;
  }

  const status = (informe.stInforme || "").trim().toUpperCase();
  if (status && status !== "AT") {
    return false;
  }

  const inicio = informe.dtInicioInforme
    ? new Date(informe.dtInicioInforme)
    : null;
  const fim = informe.dtFimInforme ? new Date(informe.dtFimInforme) : null;

  if (inicio && !isNaN(inicio.getTime()) && agora < inicio) {
    return false;
  }
  if (fim && !isNaN(fim.getTime()) && agora > fim) {
    return false;
  }

  return true;
}

/**
 * Retorna os informes de um evento específico (abrangência E) que estejam
 * vigentes e vinculados ao código de audiência informado.
 */
export function filtrarInformesDoEvento(
  informes: InformeEvento[],
  codAudienciaPublica: number | string | null | undefined
): InformeEvento[] {
  if (codAudienciaPublica === null || codAudienciaPublica === undefined) {
    return [];
  }
  const chave = Number(codAudienciaPublica);
  if (Number.isNaN(chave)) {
    return [];
  }
  return informes.filter(
    (informe) =>
      isInformeEvento(informe) &&
      isInformeVigente(informe) &&
      Number(informe.nuEventoVinculo) === chave
  );
}
